import axios from "axios";
import { compressSync, strToU8 } from "fflate";
import { pipe } from "ramda";
import useAppStore from "../stores/appStore";
import { isProd } from "@utils";
import { setResponseErrorInterceptor } from "./responseInterceptors";

const disableGzip = !isProd();
setResponseErrorInterceptor(axios);

const gzipJSON = pipe(JSON.stringify, strToU8, compressSync);

const handleContentType = (requestData) => {
  const { selectedAssistant, selectedAccountId } = useAppStore.getState();

  let contentType = "application/json";

  if (requestData?.constructor === FormData) {
    contentType = "multipart/form-data";
    requestData.append("roomId", selectedAssistant?.assistantId);
    requestData.append("accountId", selectedAccountId);
  }
  else {
    if (typeof requestData === "object") {
      requestData.accountId = selectedAccountId;
      requestData.roomId = selectedAssistant?.assistantId;
    }
    else {
      requestData = {
        accountId: selectedAccountId,
        roomId: selectedAssistant?.assistantId
      };
    }
    requestData = disableGzip ? requestData : gzipJSON(requestData);
  }
  return { contentType, requestData };
};

const createRequest = (service, subService, method) => async (data, headers) => {
  const { contentType, requestData } = handleContentType(data);
  const response = await axios({
    url: `${import.meta.env.VITE_DASHBOARD_API_URL}/${service}/${subService}`,
    method,
    headers: {
      ...(disableGzip ? {} : { "Content-Encoding": "gzip" }),
      "Content-Type": contentType,
      ...(headers || {})
    },
    data: requestData
  });

  return response.data;
};

const makeService = ({ service, subservices }) => {
  const routes = {};
  Object.keys(subservices).forEach((method) => {
    const subServices = subservices[method];
    subServices.forEach(
      subService =>
        (routes[subService] = createRequest(service, subService, method))
    );
  });
  return routes;
};

export default makeService;
